import { api } from "@/lib/api";

// Small facade over Phase-4 endpoints so each screen can stay declarative.
export const ric = {
  // masters
  bins: () => api.get("/ric/bins").then((r) => r.data),
  yarnItems: (bin_id) => api.get("/ric/yarn-items", { params: bin_id ? { bin_id } : {} }).then((r) => r.data),
  createYarnItem: (body) => api.post("/ric/yarn-items", body).then((r) => r.data),
  // movements
  receive: (body) => api.post("/ric/receipts", body).then((r) => r.data),
  transfer: (body) => api.post("/ric/transfers", body).then((r) => r.data),
  weaverSale: (body) => api.post("/ric/weaver-sales", body).then((r) => r.data),
  movements: (limit = 50) => api.get("/ric/movements", { params: { limit } }).then((r) => r.data),
  // POs
  raisePO: (body) => api.post("/ric/yarn-pos", body).then((r) => r.data),
  listPOs: (status) => api.get("/ric/yarn-pos", { params: status ? { status } : {} }).then((r) => r.data),
  acceptPO: (id, body) => api.post(`/ric/yarn-pos/${id}/accept`, body).then((r) => r.data),
  buildDespatch: (id, body) => api.post(`/ric/yarn-pos/${id}/despatch`, body).then((r) => r.data),
  despatches: () => api.get("/ric/despatches").then((r) => r.data),
  // MG side
  receipt: (id, body) => api.post(`/mg/yarn-pos/${id}/receive`, body).then((r) => r.data),
  raiseReturn: (id, body) => api.post(`/mg/yarn-pos/${id}/return`, body).then((r) => r.data),
  discrepancies: () => api.get("/ric/discrepancies").then((r) => r.data),
  closeDiscrepancy: (id, body) => api.post(`/ric/discrepancies/${id}/close`, body).then((r) => r.data),
  // counts
  openCount: (body) => api.post("/ric/counts", body).then((r) => r.data),
  walk: (cid, body) => api.post(`/ric/counts/${cid}/walk`, body).then((r) => r.data),
  submitCount: (cid) => api.post(`/ric/counts/${cid}/submit`).then((r) => r.data),
  counts: () => api.get("/ric/counts").then((r) => r.data),
  // HAG read-only
  tradeLog: () => api.get("/hag/ric/trade-log").then((r) => r.data),
  // OTP inbox
  mintOtp: (username) => api.post("/ric/otp/mint", { username }).then((r) => r.data),
};
